import './Loader.css';

/**
 * Loader reutilizable.
 * - Por defecto: spinner centrado con mensaje opcional (carga de pantallas).
 * - inline: spinner chico que hereda el color del texto (acciones en botones).
 */
function Loader({ mensaje, inline = false }) {
    if (inline) {
        return <span className="loader__spinner loader__spinner--inline" aria-hidden="true" />;
    }

    return (
        <div className="loader" role="status" aria-live="polite">
            <span className="loader__spinner" aria-hidden="true" />
            {mensaje && <span className="loader__text">{mensaje}</span>}
        </div>
    );
}

export default Loader;
